<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      class="storageOrderEdit"
      :title="disabled ? '详情' : filter.pkid > 0 ? '编辑' : '新建 '"
      :close-on-click-modal="false"
      width="1000px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="filter"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="filter.pkid > 0" :span="12">
          <el-form-item label="入库单号">
            <el-input v-model="filter.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入库类型" prop="inStockType">
            <el-select v-model="filter.inStockType" placeholder="请选择入库类型" clearable>
              <el-option label="采购入库" :value="0"/>
              <el-option label="生产入库" :value="1" disabled/>
              <el-option label="调拨入库" :value="2"/>
              <el-option label="退回入库" :value="3"/>
              <el-option label="退料入库" :value="4"/>
              <el-option label="赠送入库" :value="5"/>
              <el-option label="借用入库" :value="6"/>
              <el-option label="盘盈入库" :value="7"/>
              <el-option label="其他入库" :value="8"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="filter.pkid > 0" :span="12">
          <el-form-item label="状态">
            <el-input v-model="filter.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单号">
            <el-input v-model="filter.relBillNo" placeholder="请输入关联单号" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到货时间">
            <el-date-picker
                v-model="filter.receiptDate"
                placeholder="请选择到货时间"
                type="datetime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商">
            <el-input v-model="filter.supplierName" clearable placeholder="请选择供应商">
              <el-button v-if="!disabled" slot="append" @click="$refs.supplierSelect.open()"> 选择 </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="filter.pkid > 0" :span="12">
          <el-form-item label="制单时间">
            <el-input v-model="filter.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="filter.pkid > 0" :span="12">
          <el-form-item label="制单人">
            <el-input v-model="filter.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="备注">
            <el-input v-model="filter.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">入库明细</div>
      <el-button v-if="!disabled" type="primary" style="margin-bottom: 10px" @click="$refs.materialSelect.open()"> 添加 </el-button>
      <el-table class="tableBox" :data="filter.details" border height="300px">
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column
            prop="materialName"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            width="380"/>
        <el-table-column align="center" label="入库数量" width="100" prop="quantity">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" placeholder="请输入" @change="checkQuantity(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column align="center" label="库位" min-width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.locationName" readonly placeholder="请选择">
              <el-button v-if="!disabled" slot="append" @click="$refs.warehouseSelect.open(),setIndex(scope.$index)"> 选择 </el-button>
            </el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="specification"
            align="left"
            show-overflow-tooltip
            label="规格型号"
            width="120"/> -->
        <!-- <el-table-column prop="unitName" align="center" label="单位" width="80"/> -->
        <!-- <el-table-column prop="note" align="center" label="备注" width="240">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.note" type="textarea" autosize placeholder="请输入备注"/>
          </template>
        </el-table-column> -->
        <el-table-column v-if="!disabled" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteMaterial(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <material-select ref="materialSelect" @select="materialSelect"/>
    <supplier-select ref="supplierSelect" @select="supplierSelect"/>
    <warehouse-select ref="warehouseSelect" @select="kwSelect"/>
    <div slot="footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" type="primary" size="mini" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import MaterialSelect from "../../information/Material/MaterialMoreSelect";
  import SupplierSelect from "../../information/SupplierManage/SupplierSelect";
  import WarehouseSelect from "@/views/information/WarehouseLocation/WarehouseLocationSelect";
  export default {
    name: "StorageOrderEdit",
    components: { MaterialSelect, SupplierSelect, WarehouseSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled: false,
        locationList: [],
        filter: {
          pkid:"",
          inStockType: 0,
          inStockTypeName:"",
          billNo: "",
          relBillNo: "",
          supplierId: "",
          status: 0,
          note:"",
          supplierName: "",
          receiptDate: "",
          createTime: "",
          creatorName: "",
          details: [],
        },
        ruleValidate: {
          inStockType: { required: true, message: "请选择入库类型", trigger: "change" },
          quantity: { required: true, trigger: "blur" },
          locationName:{required:true, trigger: "blur"},
        },
      };
    },
    methods: {
      //页面开启
      open(row, disabled) { 
        console.log(row);
        this.dialogVisible = true;
        this.getLocationList();
        if (row) {
          this.filter.pkid = row.pkid;
          this.getData();
        }
        if (disabled) {
          this.disabled = true;
        }
      },

      //编辑时获取已有数据
      getData() {
        this.contentLoading = true;
        this.$http.get("basic", `inStockBills/${this.filter.pkid}`).then((resp) => {
          if(resp.success) {
            this.filter = Object.assign(this.filter,resp.data);
          }
          console.log(this.filter);
          this.contentLoading = false;
        }).catch(() => {
          this.contentLoading = false;
        });
      },

      getLocationList() {
        this.$http.get("basic", "warehouseLocations/getAllList").then((resp) => {
          if (resp.success) {
            this.locationList = resp.data;
          }
        });
      },

      //供应商选择
      supplierSelect(row) {
        this.filter.supplierName = row.name;
        this.filter.supplierId = row.pkid;
      },

      //物料选择
      materialSelect(selection) {
        selection.forEach(row=>{
          let details = {
            price: "",
            quantity: 1,
            locationName: row.warehouseLocationName,
            locationId: row.locationId,
            materialId: row.materialID,
            materialName: row.materialName,
            materialNo: row.materialNO,
            unitName: row.unitName,
            specification: row.specification,
            note: row.note,
          };
          this.filter.details.push(details);
        });
      },

      checkQuantity(row) {
        const reg = /^[0-9]*.\d{0,2}$/;
        if (!reg.test(row.quantity) || row.quantity <= 0) {
          this.$confirm("请输入正确的送货数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }      
      },

      //获取详情行索引值
      setIndex(val) {
        console.log(val);
        this.index = val;
      },

      //删除物料
      deleteMaterial(index) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.filter.details.splice(index, 1);
        });
      },

      //库位选择
      kwSelect(row) {
        console.log(row);
        this.filter.details[this.index].locationId = row.pkId;
        this.filter.details[this.index].locationName = row.warehouseLocationName;
      },


      //提交表单数据
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if(!this.filter.details.length) {
              this.$confirm("请添加入库明细", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            let next = true;
            this.filter.details.forEach(item=>{
              if(item.quantity === "" || item.quantity === null) {
                next = false;
                this.$message.error("请输入入库数量！");
              } 
              if(item.locationName === "" || item.locationName===null) {
                next = false;
                this.$message.error("请选择库位！");
              }
            });
            if(next) {
              this.submitLoading = true;
              this.$http
                .save("basic", "inStockBills", this.filter)
                .then((resp) => {
                  this.submitLoading = false;
                  if (resp.success) {
                    if (this.pkid > 0) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                    } else {
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                    }
                    this.dialogVisible = false;
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },

    },
  };
</script>

<style lang="scss" scoped>
.storageOrderEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.storageOrderEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.storageOrderEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.storageOrderEdit .el-divider--horizontal {
  margin: 10px 0;
}

.storageOrderEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

// 加载效果水平垂直居中
.el-loading-spinner {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
}
// 标题
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
</style>
